import { useEffect, useRef, useState } from 'react';
import video from '../../Assets/videos/Hospitalvideosfinal.mp4';

const headingWords = ['Bringing', 'Back', 'Your', 'Happy', 'Smile'];

const Hero = () => {
  const [visibleWords, setVisibleWords] = useState(0);
  const [fadeOut, setFadeOut] = useState(false);
  const videoRef = useRef(null);
  const lastTimeRef = useRef(0);
  const timers = useRef({ interval: null, timeout: null });

  const resetAndStartAnimation = () => {
    // 1. Reset states
    setFadeOut(false);
    setVisibleWords(0);

    // 2. Clear previous timers to prevent overlaps on loop
    clearInterval(timers.current.interval);
    clearTimeout(timers.current.timeout);

    const revealDelay = 500;

    // 3. Reveal words one by one
    timers.current.interval = setInterval(() => {
      setVisibleWords((prev) => {
        if (prev < headingWords.length) return prev + 1;
        clearInterval(timers.current.interval);
        return prev;
      });
    }, revealDelay);

    // 4. Fade out everything after a pause
    timers.current.timeout = setTimeout(() => {
      setFadeOut(true);
    }, headingWords.length * revealDelay + 2500);
  };

  const handleTimeUpdate = () => {
    const currentTime = videoRef.current.currentTime;
    // Detect video loop
    if (currentTime < lastTimeRef.current) {
      resetAndStartAnimation();
    }
    lastTimeRef.current = currentTime;
  };

  return (
    <section className="relative h-screen flex items-center overflow-hidden">
      {/* Background Video */}
      <video
        ref={videoRef}
        autoPlay
        loop
        muted
        playsInline
        onTimeUpdate={handleTimeUpdate}
        onLoadedMetadata={resetAndStartAnimation}
        className="absolute inset-0 w-full h-full object-cover"
      >
        <source src={video} type="video/mp4" />
      </video>

      {/* Content Container - Aligned Left */}
      <div
        className={`relative z-10 w-full max-w-7xl mx-auto px-8 md:px-20 transition-opacity duration-1000 
          ${fadeOut ? 'opacity-0' : 'opacity-100'}`}
      >
        {/* BACKGROUND GRADIENT: Only displays when text starts (visibleWords > 0) */}
        <div 
          className={`absolute inset-0 -left-10 w-full md:w-[600px] h-full bg-gradient-to-r from-white/80 via-white/40 to-transparent -z-10 transition-opacity duration-1000
            ${visibleWords > 0 ? 'opacity-100' : 'opacity-0'}`} 
        />
        
        {/* TEXT: Aligned Left */}
        <h1 className="flex flex-wrap justify-center  gap-2 md:gap-3 text-4xl sm:text-5xl md:text-6xl font-bold text-red-800 leading-tight">
          {headingWords.map((word, index) => (
            <span
              key={`${index}-${fadeOut}`}
              className={`inline-block transition-all duration-700 ease-out
                ${index < visibleWords 
                  ? 'translate-x-0 opacity-100' 
                  : '-translate-x-4 opacity-0'}`}
            >
              {word}
            </span>
          ))}
        </h1>
      </div>
    </section>
  );
};

export default Hero;